import React, { Fragment, useContext, useState, useEffect } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import { useSidebar } from "./SidebarContext";
import logo from '../../../images/logo no bg-03.png';
import logIcon from '../../../images/logo no bg-01.png';

const NavHader = () => {
  const [toggle, setToggle] = useState(false);
  const { navigationHader, openMenuToggle, background } = useContext(
    ThemeContext
  );
  const { isOpen, toggleSidebar } = useSidebar();

  // Sync hamburger state with sidebar state
  useEffect(() => {
    setToggle(isOpen);
  }, [isOpen]);

  const handleToggle = () => {
    setToggle(!toggle);
    toggleSidebar();
  };

  return (
    <div className="nav-header">
      <Link to="/task/tasklist" className="brand-logo">
        {/* Mini logo for sidebar collapsed or small screens */}
        <span className={`brand-logo-mini${!isOpen ? ' show' : ''}`}>
          <img src={logIcon} alt="Logo Mini" style={{ height: '50px' }} />
        </span>
        {/* Normal logo for expanded sidebar */}
        <span className={`brand-logo-normal${isOpen ? ' show' : ''}`}>
          {background.value === "dark" || navigationHader !== "color_1" ? (
            <Fragment>
              <div className="brand-title">
                <img src={logo} alt="Logo" className="public-navbar-logo-img" style={{ height: '56px' }} />
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <div className="brand-title">
                <img src={logo} alt="Logo" className="public-navbar-logo-img" style={{ height: '56px' }} />
              </div>
            </Fragment>
          )}
        </span>
      </Link>

      <div
        className="nav-control"
        onClick={handleToggle}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
